(() => {
  class SandlotProductTabs extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.tabs = [...this.querySelectorAll('[data-sg-tab]')];
      this.panels = [...this.querySelectorAll('[data-sg-tab-panel]')];
      if (!this.tabs.length) return;
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', event => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.select(index);
        }, options);
        tab.addEventListener('keydown', event => {
          let target;
          if (event.key === 'ArrowRight') target = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') target = (index + this.tabs.length - 1) % this.tabs.length;
          if (event.key === 'Home') target = 0;
          if (event.key === 'End') target = this.tabs.length - 1;
          if (event.key === ' ' || event.key === 'Enter') target = index;
          if (target === undefined) return;
          event.preventDefault();
          this.select(target, true);
        }, options);
      });
      this.addEventListener('shopify:block:select', event => {
        const index = this.panels.findIndex(panel => panel.dataset.blockId === event.detail.blockId);
        if (index >= 0) this.select(index);
      }, options);
      this.select(0);
    }
    select(index, focus = false) {
      this.tabs.forEach((tab, position) => {
        tab.setAttribute('aria-selected', String(position === index));
        tab.tabIndex = position === index ? 0 : -1;
      });
      this.panels.forEach((panel, position) => { panel.hidden = position !== index; });
      const panel = this.panels[index];
      const track = panel?.querySelector('[data-sg-track]');
      if (track && this.active !== index) track.scrollLeft = 0;
      panel?.querySelector('sandlot-carousel')?.update?.();
      this.active = index;
      if (focus) this.tabs[index].focus();
    }
    disconnectedCallback() { this.controller?.abort(); }
  }
  if (!customElements.get('sandlot-product-tabs')) customElements.define('sandlot-product-tabs', SandlotProductTabs);
})();
